import { Toaster } from '../objects/ToasterObject';
import { BodyOutputType, ToasterService } from 'angular2-toaster';
import * as i0 from "@angular/core";
import * as i1 from "angular2-toaster/src/toaster.service";
var ToasterMessageService = /** @class */ (function () {
    function ToasterMessageService(toasterService) {
        this.toasterService = toasterService;
        this.toasterObject = [];
    }
    ToasterMessageService.prototype.pushToaster = function (toast) {
        this.toasterObject.push(toast);
    };
    ToasterMessageService.prototype.getToaster = function () {
        return this.toasterObject;
    };
    ToasterMessageService.prototype.clearToaster = function () {
        this.toasterObject = [];
    };
    ToasterMessageService.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            timeout: 10000,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    ToasterMessageService.ngInjectableDef = i0.defineInjectable({ factory: function ToasterMessageService_Factory() { return new ToasterMessageService(i0.inject(i1.ToasterService)); }, token: ToasterMessageService, providedIn: "root" });
    return ToasterMessageService;
}());
export { ToasterMessageService };
